import Popper from "vue3-popper"

import './style.css'

export default Popper
